<mat-nav-list
  [ngClass]="{'sg-nav-expanded': isExpanded, 'sg-nav-contracted': !isExpanded, 'floating-navbar': isFloatingSideBar}"
  data-test="navMenu"
  class="sg-nav-menu sg-highlight-new-loans hiding-scrollbar sg-flex-column sg-fill">
  @if (showExpander && expanderPosition=='top') {
  <ng-container [ngTemplateOutlet]="expander"></ng-container>
  } @if (showLogo) {
  <mat-list-item class="app-logo-item" disableRipple>
    <div class="app-logo" [routerLink]="navBarHomeLink" [class.logo-and-app-name]="showAppName && showLogo" [class.is-expanded]="isExpanded">
      <button mat-icon-button class="sg-nav-main-icon" disableRipple><img [src]="logoSrc" /></button>
      @if (showAppName && isExpanded) {
      <div class="app-name">{{appName}}</div>
      }
    </div>
  </mat-list-item>
  }
  <div
    #sidenavContent
    [ngClass]="{ 'sg-borrower-layout' : isBorrower, 'nav-items-with-app-name': showAppName }"
    class="sg-flex-column sg-nav-menu-items hiding-scrollbar sg-flex-auto">
    @for (mi of topMenuItems$ | async; track $index) { @if (!isNavGroup(mi) && mi) {
    <a
      mat-list-item
      class="sg-nav-menu-item mat-menu-item"
      [routerLink]="mi.disabled ? null : mi.url"
      [class.sg-nav-menu-item-active]="activeRoute === mi.url"
      [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
      [class.sg-nav-menu-item-disabled]="mi.disabled"
      [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
      #rla="routerLinkActive"
      [routerLinkActiveOptions]="{exact: false}"
      [attr.disabled]="activeRoute === mi.url || mi.disabled ? true : null"
      [style.pointer-events]="mi.disabled ? 'none' : 'auto'"
      (click)="!mi.disabled && onActivate(mi)">
      <div class="sg-full-width">
        <ng-container *ngTemplateOutlet="mi?.parent ? indentBlock : undefined; context: { $implicit: mi?.parent }"></ng-container>
        <div class="sg-flex-auto">
          <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: mi, expanded: mi.expanded, ctrl: ctrlContext }"></ng-container>
        </div>
      </div>
    </a>
    } @if (isNavGroup(mi) && mi) {
    <div class="sg-nav-menu-item-group-container">
      <button mat-list-item class="sg-nav-menu-item" (click)="updateGroup(mi, trigger)" (mousedown)="trigger._handleMousedown($event)">
        <div class="sg-full-width">
          <ng-container *ngTemplateOutlet="mi?.parent ? indentBlock : undefined; context: { $implicit: mi?.parent }"></ng-container>
          <div class="sg-flex-auto">
            <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: mi, expanded: mi.expanded, isGroup: true, ctrl: ctrlContext }"></ng-container>
          </div>
        </div>
      </button>
      <!-- Placeholder menu so menu is opened at the end of the menu item (horizontal) -->
      <!-- https://github.com/angular/material2/pull/8401 -->
      <span class="sg-overlay-menu-placeholder" [sgNavMenuTriggerFor]="iconModeMenu" #trigger="sgNavMenuTrigger"></span>
    </div>
    @if (mi.expanded && isExpanded) {
    <div class="sg-nav-menu-menu-container" [@slideInOut]="'in'" (@slideInOut.start)="menuItemAnimationStart()" (@slideInOut.done)="menuItemAnimationEnd()">
      @for (cmi of mi.children; track $index) { @if (!isNavGroup(cmi) && cmi) {
      <a
        mat-list-item
        class="sg-nav-menu-item mat-menu-item"
        [routerLink]="cmi.disabled ? null : cmi.url"
        [class.sg-nav-menu-item-active]="activeRoute === cmi.url"
        [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
        [class.sg-nav-menu-item-disabled]="cmi.disabled"
        [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
        #rla="routerLinkActive"
        [routerLinkActiveOptions]="{exact: false}"
        [attr.disabled]="activeRoute === cmi.url || cmi.disabled ? true : null"
        [style.pointer-events]="cmi.disabled ? 'none' : 'auto'"
        (click)="!cmi.disabled && onActivate(cmi)">
        <div class="sg-full-width">
          <ng-container *ngTemplateOutlet="cmi?.parent ? indentBlock : undefined; context: { $implicit: cmi?.parent }"></ng-container>
          <div class="sg-flex-auto">
            <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: cmi, expanded: mi.expanded, ctrl: ctrlContext }"></ng-container>
          </div>
        </div>
      </a>
      } @if (isNavGroup(cmi) && cmi) {
      <ng-template [ngTemplateOutlet]="itemGroup" [ngTemplateOutletContext]="{ $implicit: cmi }"></ng-template>
      } }
    </div>
    }
    <mat-menu #iconModeMenu="matMenu" class="sg-nav-menu sg-nav-fly-menu" (closed)="mi.expanded = !mi.expanded">
      <div class="sg-nav-menu-header sg-color-disabled" translate>{{mi.label}}</div>
      @for (cmi of mi.children; track $index) { @if (!isNavGroup(cmi) && cmi) {
      <a
        mat-list-item
        class="sg-nav-menu-item mat-menu-item"
        [routerLink]="cmi.disabled ? null : cmi.url"
        [class.sg-nav-menu-item-active]="activeRoute === cmi.url"
        [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
        [class.sg-nav-menu-item-disabled]="cmi.disabled"
        [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
        #rla="routerLinkActive"
        [routerLinkActiveOptions]="{exact: false}"
        [attr.disabled]="activeRoute === cmi.url || cmi.disabled ? true : null"
        [style.pointer-events]="cmi.disabled ? 'none' : 'auto'"
        (click)="!cmi.disabled && onActivate(cmi)">
        <div class="sg-full-width">
          <ng-container *ngTemplateOutlet="cmi?.parent ? indentBlock : undefined; context: { $implicit: cmi?.parent }"></ng-container>
          <div class="sg-flex-auto">
            <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: cmi, expanded: mi.expanded, ctrl: ctrlContext }"></ng-container>
          </div>
        </div>
      </a>
      } @if (isNavGroup(cmi);) {
      <button mat-menu-item class="sg-nav-menu-item" [matMenuTriggerFor]="subMenu">
        <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: cmi, ctrl: ctrlContext }"></ng-container>
      </button>
      <mat-menu #subMenu="matMenu" class="sg-nav-menu" (closed)="cmi.expanded = !cmi.expanded">
        @for (subCmi of cmi.children; track $index) { @if (!isNavGroup(subCmi) && subCmi) {
        <a
          mat-list-item
          class="sg-nav-menu-item mat-menu-item"
          [routerLink]="subCmi.disabled ? null : subCmi.url"
          [class.sg-nav-menu-item-active]="activeRoute === subCmi.url"
          [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
          [class.sg-nav-menu-item-disabled]="subCmi.disabled"
          [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
          #rla="routerLinkActive"
          [routerLinkActiveOptions]="{exact: false}"
          [attr.disabled]="activeRoute === subCmi.url || subCmi.disabled ? true : null"
          [style.pointer-events]="subCmi.disabled ? 'none' : 'auto'"
          (click)="!subCmi.disabled && onActivate(subCmi)">
          <div class="sg-full-width">
            <ng-container *ngTemplateOutlet="subCmi?.parent ? indentBlock : undefined; context: { $implicit: subCmi?.parent }"></ng-container>
            <div class="sg-flex-auto">
              <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: subCmi, expanded: cmi.expanded, ctrl: ctrlContext }"></ng-container>
            </div>
          </div>
        </a>
        } @if (isNavGroup(subCmi) && subCmi) {
        <ng-template [ngTemplateOutlet]="itemGroup"></ng-template>
        } }
      </mat-menu>
      } }
    </mat-menu>
    } }
    <span class="sg-flex-auto"></span>
    @for (mi of bottomMenuItems$ | async; track $index) { @if (!isNavGroup(mi) && mi) {
    <a
      mat-list-item
      class="sg-nav-menu-item mat-menu-item"
      [routerLink]="mi.disabled ? null : mi.url"
      [class.sg-nav-menu-item-active]="activeRoute === mi.url"
      [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
      [class.sg-nav-menu-item-disabled]="mi.disabled"
      [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
      #rla="routerLinkActive"
      [routerLinkActiveOptions]="{exact: false}"
      [attr.disabled]="activeRoute === mi.url || mi.disabled ? true : null"
      [style.pointer-events]="mi.disabled ? 'none' : 'auto'"
      (click)="!mi.disabled && onActivate(mi)">
      <div class="sg-full-width">
        <ng-container *ngTemplateOutlet="mi?.parent ? indentBlock : undefined; context: { $implicit: mi?.parent }"></ng-container>
        <div class="sg-flex-auto">
          <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: mi, expanded: mi.expanded, ctrl: ctrlContext }"></ng-container>
        </div>
      </div>
    </a>
    } @if (isNavGroup(mi) && mi) {
    <div class="sg-nav-menu-item-group-container">
      <button mat-list-item class="sg-nav-menu-item" (click)="updateGroup(mi, trigger)" (mousedown)="trigger._handleMousedown($event)">
        <div class="sg-full-width">
          <ng-container *ngTemplateOutlet="mi?.parent ? indentBlock : undefined; context: { $implicit: mi?.parent }"></ng-container>
          <div class="sg-flex-auto">
            <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: mi, expanded: mi.expanded, isGroup: true, ctrl: ctrlContext }"></ng-container>
          </div>
        </div>
      </button>
      <!-- Placeholder menu so menu is opened at the end of the menu item (horizontal) -->
      <!-- https://github.com/angular/material2/pull/8401 -->
      <span class="sg-overlay-menu-placeholder" [sgNavMenuTriggerFor]="iconModeMenu" #trigger="sgNavMenuTrigger"></span>
    </div>
    @if (mi.expanded && isExpanded) {
    <div class="sg-nav-menu-menu-container" [@slideInOut]="'in'" (@slideInOut.start)="menuItemAnimationStart()" (@slideInOut.done)="menuItemAnimationEnd()">
      @for (cmi of mi.children; track $index) { @if (!isNavGroup(cmi) && cmi) {
      <a
        mat-list-item
        class="sg-nav-menu-item mat-menu-item"
        [routerLink]="cmi.disabled ? null : cmi.url"
        [class.sg-nav-menu-item-active]="activeRoute === cmi.url"
        [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
        [class.sg-nav-menu-item-disabled]="cmi.disabled"
        [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
        #rla="routerLinkActive"
        [routerLinkActiveOptions]="{exact: false}"
        [attr.disabled]="activeRoute === cmi.url || cmi.disabled ? true : null"
        [style.pointer-events]="cmi.disabled ? 'none' : 'auto'"
        (click)="!cmi.disabled && onActivate(cmi)">
        <div class="sg-full-width">
          <ng-container *ngTemplateOutlet="cmi?.parent ? indentBlock : undefined; context: { $implicit: cmi?.parent }"></ng-container>
          <div class="sg-flex-auto">
            <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: cmi, expanded: mi.expanded, ctrl: ctrlContext }"></ng-container>
          </div>
        </div>
      </a>
      } @if (isNavGroup(cmi) && cmi) {
      <ng-template [ngTemplateOutlet]="itemGroup" [ngTemplateOutletContext]="{ $implicit: cmi }"></ng-template>
      } }
    </div>
    }
    <mat-menu #iconModeMenu="matMenu" class="sg-nav-menu sg-nav-fly-menu" (closed)="mi.expanded = !mi.expanded">
      <div class="sg-nav-menu-header sg-color-disabled" translate>{{mi.label}}</div>
      @for (cmi of mi.children; track $index) { @if (!isNavGroup(cmi) && cmi) {
      <a
        mat-list-item
        class="sg-nav-menu-item mat-menu-item"
        [routerLink]="cmi.disabled ? null : cmi.url"
        [class.sg-nav-menu-item-active]="activeRoute === cmi.url"
        [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
        [class.sg-nav-menu-item-disabled]="cmi.disabled"
        [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
        #rla="routerLinkActive"
        [routerLinkActiveOptions]="{exact: false}"
        [attr.disabled]="activeRoute === cmi.url || cmi.disabled ? true : null"
        [style.pointer-events]="cmi.disabled ? 'none' : 'auto'"
        (click)="!cmi.disabled && onActivate(cmi)">
        <div class="sg-full-width">
          <ng-container *ngTemplateOutlet="cmi?.parent ? indentBlock : undefined; context: { $implicit: cmi?.parent }"></ng-container>
          <div class="sg-flex-auto">
            <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: cmi, expanded: mi.expanded, ctrl: ctrlContext }"></ng-container>
          </div>
        </div>
      </a>
      } @if (isNavGroup(cmi);) {
      <button mat-menu-item class="sg-nav-menu-item" [matMenuTriggerFor]="subMenu">
        <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: cmi, ctrl: ctrlContext }"></ng-container>
      </button>
      <mat-menu #subMenu="matMenu" class="sg-nav-menu" (closed)="cmi.expanded = !cmi.expanded">
        @for (subCmi of cmi.children; track $index) { @if (!isNavGroup(subCmi) && subCmi) {
        <a
          mat-list-item
          class="sg-nav-menu-item mat-menu-item"
          [routerLink]="subCmi.disabled ? null : subCmi.url"
          [class.sg-nav-menu-item-active]="activeRoute === subCmi.url"
          [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
          [class.sg-nav-menu-item-disabled]="subCmi.disabled"
          [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
          #rla="routerLinkActive"
          [routerLinkActiveOptions]="{exact: false}"
          [attr.disabled]="activeRoute === subCmi.url || subCmi.disabled ? true : null"
          [style.pointer-events]="subCmi.disabled ? 'none' : 'auto'"
          (click)="!subCmi.disabled && onActivate(subCmi)">
          <div class="sg-full-width">
            <ng-container *ngTemplateOutlet="subCmi?.parent ? indentBlock : undefined; context: { $implicit: subCmi?.parent }"></ng-container>
            <div class="sg-flex-auto">
              <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: subCmi, expanded: cmi.expanded, ctrl: ctrlContext }"></ng-container>
            </div>
          </div>
        </a>
        } @if (isNavGroup(subCmi) && subCmi) {
        <ng-template [ngTemplateOutlet]="itemGroup"></ng-template>
        } }
      </mat-menu>
      } }
    </mat-menu>
    } } @if (showExpander && expanderPosition=='bottom') {
    <ng-container [ngTemplateOutlet]="expander"></ng-container>
    } @if (showNotifications && menuItemsAdded) {
    <div class="sg-notification-item">
      <mat-list-item (click)="onNotificationsClick($event)" class="clickable-notification">
        <div class="notifications">
          <div class="notification-icon-container">
            <mat-icon>notifications_none</mat-icon>
            @if (notificationsNum > 0 && !isExpanded) {
            <sg-counter-badge
              class="notifications-badge-dot"
              [value]="notificationsNum"
              color="error"
              size="small"
              [variant]="'dot'"
              data-test="counterDot"></sg-counter-badge>
            }
          </div>
          <div class="item-txt" [class.hide-item-txt]="!isExpanded">Notifications</div>
          @if (notificationsNum > 0 && isExpanded && isExpandAnimationComplete) {
          <sg-counter-badge
            class="notifications-badge-counter"
            [value]="notificationsNum"
            color="error"
            size="small"
            [variant]="'counter'"
            data-test="counterLabel"></sg-counter-badge>
          }
        </div>
      </mat-list-item>
    </div>
    }
    <!-- Admin has no user menu to open here (it registers no UserMenuService, so the row is a
         non-clickable avatar + name) and shows the signed-in user in its own top bar, so the
         block is suppressed for sg-admin only. EMT and Lender both rely on it — EMT hides the
         top bar entirely, making this its only user affordance — hence an appName gate rather
         than the `showUserMenu` input, which is also false for borrower/lead/analyzer. -->
    @if (firstName && env.appName !== 'sg-admin') {
    <div class="user-menu-container" data-test="user-menu-container">
      @if ({ userMenuGroups: getUserMenuGroups() }; as vm) {
      <mat-list-item
        class="user-menu-item"
        [matMenuTriggerFor]="vm.userMenuGroups.length > 0 ? userMenuRef.matMenu : null"
        #userMenuTrigger="matMenuTrigger"
        [matMenuTriggerRestoreFocus]="false"
        (menuOpened)="onUserMenuOpened(userMenuTrigger)"
        (menuClosed)="onUserMenuClosed()"
        data-test="user-menu-trigger">
        <div class="user-menu" data-test="user-menu">
          <sg-avatar [firstName]="firstName" [lastName]="lastName" [size]="'medium'" [showTooltip]="false" data-test="user-avatar"></sg-avatar>
          <div class="user-details" [class.hide-item-txt]="!isExpanded" data-test="user-details">
            <sg-text variant="sg-body-medium-bold" data-test="user-name">{{ (firstName + ' ' + lastName).trim() }}</sg-text>
            @if (getUserSubtitle()) {
            <sg-text variant="sg-body-small-regular" data-test="user-subtitle">{{ getUserSubtitle() }}</sg-text>
            } @if (accountName && !getUserSubtitle()) {
            <sg-text variant="sg-body-small-regular" data-test="account-name">{{ accountName }}</sg-text>
            }
          </div>
        </div>
      </mat-list-item>
      <sg-menu #userMenuRef [groups]="vm.userMenuGroups" [hasBackdrop]="true" data-test="user-menu-dropdown"></sg-menu>
      }
    </div>
    }
  </div>
</mat-nav-list>
<ng-template #expander>
  <mat-list-item class="icon-toggle-container" [class.bottom-expander]="expanderPosition=='bottom'" (click)="toggleExpandClick()" data-test="sidenav-expander">
    <div class="hover-block">
      <mat-icon class="expended-icon" [class.rotated-expended-icon]="!isExpanded">chevron_left</mat-icon>
      <mat-icon class="expended-icon" [class.rotated-expended-icon]="!isExpanded">chevron_left</mat-icon>
    </div>
  </mat-list-item>
</ng-template>
<ng-template #itemLink let-mi>
  <a
    mat-list-item
    class="sg-nav-menu-item mat-menu-item"
    [routerLink]="mi.disabled ? null : mi.url"
    [class.sg-nav-menu-item-active]="activeRoute === mi.url"
    [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
    [class.sg-nav-menu-item-disabled]="mi.disabled"
    [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
    #rla="routerLinkActive"
    [routerLinkActiveOptions]="{exact: false}"
    [attr.disabled]="activeRoute === mi.url || mi.disabled ? true : null"
    [style.pointer-events]="mi.disabled ? 'none' : 'auto'"
    (click)="!mi.disabled && onActivate(mi)">
    <div class="sg-full-width">
      <ng-container *ngTemplateOutlet="mi?.parent ? indentBlock : undefined; context: { $implicit: mi?.parent }"></ng-container>
      <div class="sg-flex-auto">
        <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: mi, expanded: mi.expanded, ctrl: ctrlContext }"></ng-container>
      </div>
    </div>
  </a>
</ng-template>
<ng-template #itemGroup let-mi>
  <div class="sg-nav-menu-item-group-container">
    <button mat-list-item class="sg-nav-menu-item" (click)="updateGroup(mi, trigger)" (mousedown)="trigger._handleMousedown($event)">
      <div class="sg-full-width">
        <ng-container *ngTemplateOutlet="mi?.parent ? indentBlock : undefined; context: { $implicit: mi?.parent }"></ng-container>
        <div class="sg-flex-auto">
          <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: mi, expanded: mi.expanded, isGroup: true, ctrl: ctrlContext }"></ng-container>
        </div>
      </div>
    </button>
    <!-- Placeholder menu so menu is opened at the end of the menu item (horizontal) -->
    <!-- https://github.com/angular/material2/pull/8401 -->
    <span class="sg-overlay-menu-placeholder" [sgNavMenuTriggerFor]="iconModeMenu" #trigger="sgNavMenuTrigger"></span>
  </div>
  @if (mi.expanded && isExpanded) {
  <div class="sg-nav-menu-menu-container" [@slideInOut]="'in'" (@slideInOut.start)="menuItemAnimationStart()" (@slideInOut.done)="menuItemAnimationEnd()">
    @for (cmi of mi.children; track $index) { @if (!isNavGroup(cmi) && cmi) {
    <a
      mat-list-item
      class="sg-nav-menu-item mat-menu-item"
      [routerLink]="cmi.disabled ? null : cmi.url"
      [class.sg-nav-menu-item-active]="activeRoute === cmi.url"
      [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
      [class.sg-nav-menu-item-disabled]="cmi.disabled"
      [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
      #rla="routerLinkActive"
      [routerLinkActiveOptions]="{exact: false}"
      [attr.disabled]="activeRoute === cmi.url || cmi.disabled ? true : null"
      [style.pointer-events]="cmi.disabled ? 'none' : 'auto'"
      (click)="!cmi.disabled && onActivate(cmi)">
      <div class="sg-full-width">
        <ng-container *ngTemplateOutlet="cmi?.parent ? indentBlock : undefined; context: { $implicit: cmi?.parent }"></ng-container>
        <div class="sg-flex-auto">
          <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: cmi, expanded: cmi.expanded, ctrl: ctrlContext }"></ng-container>
        </div>
      </div>
    </a>
    } @if (isNavGroup(cmi) && cmi) {
    <div class="sg-nav-menu-item-group-container">
      <button mat-list-item class="sg-nav-menu-item" (click)="updateGroup(mi, trigger)" (mousedown)="trigger._handleMousedown($event)">
        <div class="sg-full-width">
          <ng-container *ngTemplateOutlet="mi?.parent ? indentBlock : undefined; context: { $implicit: mi?.parent }"></ng-container>
          <div class="sg-flex-auto">
            <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: mi, expanded: mi.expanded, isGroup: true, ctrl: ctrlContext }"></ng-container>
          </div>
        </div>
      </button>
      <!-- Placeholder menu so menu is opened at the end of the menu item (horizontal) -->
      <!-- https://github.com/angular/material2/pull/8401 -->
      <span class="sg-overlay-menu-placeholder" [sgNavMenuTriggerFor]="iconModeMenu" #trigger="sgNavMenuTrigger"></span>
    </div>
    @if (mi.expanded && isExpanded) {
    <div class="sg-nav-menu-menu-container" [@slideInOut]="'in'" (@slideInOut.start)="menuItemAnimationStart()" (@slideInOut.done)="menuItemAnimationEnd()">
      @for (cmi of mi.children; track $index) { @if (!isNavGroup(cmi) && cmi) {
      <a
        mat-list-item
        class="sg-nav-menu-item mat-menu-item"
        [routerLink]="cmi.disabled ? null : cmi.url"
        [class.sg-nav-menu-item-active]="activeRoute === cmi.url"
        [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
        [class.sg-nav-menu-item-disabled]="cmi.disabled"
        [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
        #rla="routerLinkActive"
        [routerLinkActiveOptions]="{exact: false}"
        [attr.disabled]="activeRoute === cmi.url || cmi.disabled ? true : null"
        [style.pointer-events]="cmi.disabled ? 'none' : 'auto'"
        (click)="!cmi.disabled && onActivate(cmi)">
        <div class="sg-full-width">
          <ng-container *ngTemplateOutlet="cmi?.parent ? indentBlock : undefined; context: { $implicit: cmi?.parent }"></ng-container>
          <div class="sg-flex-auto">
            <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: cmi, expanded: mi.expanded, ctrl: ctrlContext }"></ng-container>
          </div>
        </div>
      </a>
      } @if (isNavGroup(cmi) && cmi) {
      <ng-template [ngTemplateOutlet]="itemGroup" [ngTemplateOutletContext]="{ $implicit: cmi }"></ng-template>
      } }
    </div>
    }
    <mat-menu #iconModeMenu="matMenu" class="sg-nav-menu sg-nav-fly-menu" (closed)="mi.expanded = !mi.expanded">
      <div class="sg-nav-menu-header sg-color-disabled" translate>{{mi.label}}</div>
      @for (cmi of mi.children; track $index) { @if (!isNavGroup(cmi) && cmi) {
      <a
        mat-list-item
        class="sg-nav-menu-item mat-menu-item"
        [routerLink]="cmi.disabled ? null : cmi.url"
        [class.sg-nav-menu-item-active]="activeRoute === cmi.url"
        [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
        [class.sg-nav-menu-item-disabled]="cmi.disabled"
        [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
        #rla="routerLinkActive"
        [routerLinkActiveOptions]="{exact: false}"
        [attr.disabled]="activeRoute === cmi.url || cmi.disabled ? true : null"
        [style.pointer-events]="cmi.disabled ? 'none' : 'auto'"
        (click)="!cmi.disabled && onActivate(cmi)">
        <div class="sg-full-width">
          <ng-container *ngTemplateOutlet="cmi?.parent ? indentBlock : undefined; context: { $implicit: cmi?.parent }"></ng-container>
          <div class="sg-flex-auto">
            <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: cmi, expanded: mi.expanded, ctrl: ctrlContext }"></ng-container>
          </div>
        </div>
      </a>
      } @if (isNavGroup(cmi);) {
      <button mat-menu-item class="sg-nav-menu-item" [matMenuTriggerFor]="subMenu">
        <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: cmi, ctrl: ctrlContext }"></ng-container>
      </button>
      <mat-menu #subMenu="matMenu" class="sg-nav-menu" (closed)="cmi.expanded = !cmi.expanded">
        @for (subCmi of cmi.children; track $index) { @if (!isNavGroup(subCmi) && subCmi) {
        <a
          mat-list-item
          class="sg-nav-menu-item mat-menu-item"
          [routerLink]="subCmi.disabled ? null : subCmi.url"
          [class.sg-nav-menu-item-active]="activeRoute === subCmi.url"
          [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
          [class.sg-nav-menu-item-disabled]="subCmi.disabled"
          [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
          #rla="routerLinkActive"
          [routerLinkActiveOptions]="{exact: false}"
          [attr.disabled]="activeRoute === subCmi.url || subCmi.disabled ? true : null"
          [style.pointer-events]="subCmi.disabled ? 'none' : 'auto'"
          (click)="!subCmi.disabled && onActivate(subCmi)">
          <div class="sg-full-width">
            <ng-container *ngTemplateOutlet="subCmi?.parent ? indentBlock : undefined; context: { $implicit: subCmi?.parent }"></ng-container>
            <div class="sg-flex-auto">
              <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: subCmi, expanded: cmi.expanded, ctrl: ctrlContext }"></ng-container>
            </div>
          </div>
        </a>
        } @if (isNavGroup(subCmi) && subCmi) {
        <ng-template [ngTemplateOutlet]="itemGroup"></ng-template>
        } }
      </mat-menu>
      } }
    </mat-menu>
    } }
  </div>
  }
  <mat-menu #iconModeMenu="matMenu" class="sg-nav-menu sg-nav-fly-menu" (closed)="mi.expanded = !mi.expanded">
    <div class="sg-nav-menu-header sg-color-disabled" translate>{{mi.label}}</div>
    @for (cmi of mi.children; track $index) { @if (!isNavGroup(cmi) && cmi) {
    <a
      mat-list-item
      class="sg-nav-menu-item mat-menu-item"
      [routerLink]="cmi.disabled ? null : cmi.url"
      [class.sg-nav-menu-item-active]="activeRoute === cmi.url"
      [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
      [class.sg-nav-menu-item-disabled]="cmi.disabled"
      [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
      #rla="routerLinkActive"
      [routerLinkActiveOptions]="{exact: false}"
      [attr.disabled]="activeRoute === cmi.url || cmi.disabled ? true : null"
      [style.pointer-events]="cmi.disabled ? 'none' : 'auto'"
      (click)="!cmi.disabled && onActivate(cmi)">
      <div class="sg-full-width">
        <ng-container *ngTemplateOutlet="cmi?.parent ? indentBlock : undefined; context: { $implicit: cmi?.parent }"></ng-container>
        <div class="sg-flex-auto">
          <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: cmi, expanded: cmi.expanded, ctrl: ctrlContext }"></ng-container>
        </div>
      </div>
    </a>
    } @if (isNavGroup(cmi);) {
    <button mat-menu-item class="sg-nav-menu-item" [matMenuTriggerFor]="subMenu">
      <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: cmi, ctrl: ctrlContext }"></ng-container>
    </button>
    <mat-menu #subMenu="matMenu" class="sg-nav-menu" (closed)="cmi.expanded = !cmi.expanded">
      @for (subCmi of cmi.children; track $index) { @if (!isNavGroup(subCmi) && subCmi) {
      <a
        mat-list-item
        class="sg-nav-menu-item mat-menu-item"
        [routerLink]="subCmi.disabled ? null : subCmi.url"
        [class.sg-nav-menu-item-active]="activeRoute === subCmi.url"
        [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
        [class.sg-nav-menu-item-disabled]="subCmi.disabled"
        [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
        #rla="routerLinkActive"
        [routerLinkActiveOptions]="{exact: false}"
        [attr.disabled]="activeRoute === subCmi.url || subCmi.disabled ? true : null"
        [style.pointer-events]="subCmi.disabled ? 'none' : 'auto'"
        (click)="!subCmi.disabled && onActivate(subCmi)">
        <div class="sg-full-width">
          <ng-container *ngTemplateOutlet="subCmi?.parent ? indentBlock : undefined; context: { $implicit: subCmi?.parent }"></ng-container>
          <div class="sg-flex-auto">
            <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: subCmi, expanded: cmi.expanded, ctrl: ctrlContext }"></ng-container>
          </div>
        </div>
      </a>
      } @if (isNavGroup(subCmi) && subCmi) {
      <div class="sg-nav-menu-item-group-container">
        <button mat-list-item class="sg-nav-menu-item" (click)="updateGroup(subCmi, trigger)" (mousedown)="trigger._handleMousedown($event)">
          <div class="sg-full-width">
            <ng-container *ngTemplateOutlet="subCmi?.parent ? indentBlock : undefined; context: { $implicit: subCmi?.parent }"></ng-container>
            <div class="sg-flex-auto">
              <ng-container
                *ngTemplateOutlet="navMenu.itemLink; context: { mi: subCmi, expanded: subCmi.expanded, isGroup: true, ctrl: ctrlContext }"></ng-container>
            </div>
          </div>
        </button>
        <!-- Placeholder menu so menu is opened at the end of the menu item (horizontal) -->
        <!-- https://github.com/angular/material2/pull/8401 -->
        <span class="sg-overlay-menu-placeholder" [sgNavMenuTriggerFor]="iconModeMenu" #trigger="sgNavMenuTrigger"></span>
      </div>
      @if (subCmi.expanded && isExpanded) {
      <div class="sg-nav-menu-menu-container" [@slideInOut]="'in'" (@slideInOut.start)="menuItemAnimationStart()" (@slideInOut.done)="menuItemAnimationEnd()">
        @for (subSubCmi of subCmi.children; track $index) { @if (!isNavGroup(subSubCmi) && subSubCmi) {
        <a
          mat-list-item
          class="sg-nav-menu-item mat-menu-item"
          [routerLink]="subSubCmi.disabled ? null : subSubCmi.url"
          [class.sg-nav-menu-item-active]="activeRoute === subSubCmi.url"
          [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
          [class.sg-nav-menu-item-disabled]="subSubCmi.disabled"
          [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
          #rla="routerLinkActive"
          [routerLinkActiveOptions]="{exact: false}"
          [attr.disabled]="activeRoute === subSubCmi.url || subSubCmi.disabled ? true : null"
          [style.pointer-events]="subSubCmi.disabled ? 'none' : 'auto'"
          (click)="!subSubCmi.disabled && onActivate(subSubCmi)">
          <div class="sg-full-width">
            <ng-container *ngTemplateOutlet="subSubCmi?.parent ? indentBlock : undefined; context: { $implicit: subSubCmi?.parent }"></ng-container>
            <div class="sg-flex-auto">
              <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: subSubCmi, expanded: subCmi.expanded, ctrl: ctrlContext }"></ng-container>
            </div>
          </div>
        </a>
        } @if (isNavGroup(cmi) && cmi) {
        <ng-template [ngTemplateOutlet]="itemGroup"></ng-template>
        } }
      </div>
      }
      <mat-menu #iconModeMenu="matMenu" class="sg-nav-menu sg-nav-fly-menu" (closed)="mi.expanded = !mi.expanded">
        <div class="sg-nav-menu-header sg-color-disabled" translate>{{mi.label}}</div>
        @for (cmi of mi.children; track $index) { @if (!isNavGroup(cmi) && cmi) {
        <a
          mat-list-item
          class="sg-nav-menu-item mat-menu-item"
          [routerLink]="cmi.disabled ? null : cmi.url"
          [class.sg-nav-menu-item-active]="activeRoute === cmi.url"
          [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
          [class.sg-nav-menu-item-disabled]="cmi.disabled"
          [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
          #rla="routerLinkActive"
          [routerLinkActiveOptions]="{exact: false}"
          [attr.disabled]="activeRoute === cmi.url || cmi.disabled ? true : null"
          [style.pointer-events]="cmi.disabled ? 'none' : 'auto'"
          (click)="!cmi.disabled && onActivate(cmi)">
          <div class="sg-full-width">
            <ng-container *ngTemplateOutlet="cmi?.parent ? indentBlock : undefined; context: { $implicit: cmi?.parent }"></ng-container>
            <div class="sg-flex-auto">
              <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: cmi, expanded: mi.expanded, ctrl: ctrlContext }"></ng-container>
            </div>
          </div>
        </a>
        } @if (isNavGroup(cmi);) {
        <button mat-menu-item class="sg-nav-menu-item" [matMenuTriggerFor]="subMenu">
          <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: cmi, ctrl: ctrlContext }"></ng-container>
        </button>
        <mat-menu #subMenu="matMenu" class="sg-nav-menu" (closed)="cmi.expanded = !cmi.expanded">
          @for (subCmi of cmi.children; track $index) { @if (!isNavGroup(subCmi) && subCmi) {
          <a
            mat-list-item
            class="sg-nav-menu-item mat-menu-item"
            [routerLink]="subCmi.disabled ? null : subCmi.url"
            [class.sg-nav-menu-item-active]="activeRoute === subCmi.url"
            [class.sg-nav-menu-item-active-bg]="env.appName === 'sg-admin'"
            [class.sg-nav-menu-item-disabled]="subCmi.disabled"
            [routerLinkActive]="['sg-nav-menu-item-active', env.isAdminProd ? 'sg-nav-menu-item-active-admin-prod' : null]"
            #rla="routerLinkActive"
            [routerLinkActiveOptions]="{exact: false}"
            [attr.disabled]="activeRoute === subCmi.url || subCmi.disabled ? true : null"
            [style.pointer-events]="subCmi.disabled ? 'none' : 'auto'"
            (click)="!subCmi.disabled && onActivate(subCmi)">
            <div class="sg-full-width">
              <ng-container *ngTemplateOutlet="subCmi?.parent ? indentBlock : undefined; context: { $implicit: subCmi?.parent }"></ng-container>
              <div class="sg-flex-auto">
                <ng-container *ngTemplateOutlet="navMenu.itemLink; context: { mi: subCmi, expanded: cmi.expanded, ctrl: ctrlContext }"></ng-container>
              </div>
            </div>
          </a>
          } @if (isNavGroup(subCmi) && subCmi) {
          <ng-template [ngTemplateOutlet]="itemGroup"></ng-template>
          } }
        </mat-menu>
        } }
      </mat-menu>
      } }
    </mat-menu>
    } }
  </mat-menu>
</ng-template>
<ng-template #indentBlock let-mi>
  @if (mi) {
  <div class="sg-nav-menu-indent-block"></div>
  }
  <ng-container *ngTemplateOutlet="mi?.parent ? indentBlock : undefined; context: { $implicit: mi?.parent }"></ng-container>
</ng-template>
